export default function($) {
  const postsSwiper = new Swiper('.js-posts-slider', {
    slidesPerView: 1,
    spaceBetween: 32,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
        spaceBetween: 32,
      },
      1024: {
        slidesPerView: 2,
        spaceBetween: 56,
      },
      1280: {
        slidesPerView: 3,
        spaceBetween: 56,
        pagination: false,
      },
    },
  });
}
